import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

const ReceiptAllocation = () => {
  const token = localStorage.getItem("token");

  /* ---------------- STATE ---------------- */
  const [letterOptions, setLetterOptions] = useState([]);
  const [selectedLetters, setSelectedLetters] = useState([]);

  const [mrMap, setMrMap] = useState({});
  const [receiptMap, setReceiptMap] = useState({});

  const [allocationMap, setAllocationMap] = useState({});
  const [editableKeys, setEditableKeys] = useState({});
  const [activeRowKey, setActiveRowKey] = useState(null);

  /* ---------------- FETCH CONFIRMATION LETTERS ---------------- */
  const fetchConfirmationLetters = async () => {
    const res = await apiClient.get(
      `${SERVER_BASE}/confirmation-letter`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setLetterOptions(
      (res.data || []).map((l) => ({
        value: l.id,
        label: `${l.refNo} - ${moment(l.letterDate).format("DD MMM YY")}`,
        raw: l,
      }))
    );
  };

  const fetchMRsByIds = async (mrIds) => {
    if (!mrIds.length) return;
  
    const res = await apiClient.post(
      `${SERVER_BASE}/getMrsByIds`,
      { mrIds },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  
    const map = {};
    (res.data?.data || []).forEach((mr) => {
      map[mr.id] = mr;
    });
  
    setMrMap(map);
  };
  
  const fetchReceiptsByIds = async (receiptIds) => {
    if (!receiptIds.length) return;
  
    const res = await apiClient.post(
      `${SERVER_BASE}/getReceiptsByIds`,
      { receiptIds },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const map = {};
    (res.data?.data || []).forEach((rv) => {
      map[rv.id] = rv;
    });

    setReceiptMap(map);
  };
  

  /* ---------------- LOAD LETTERS ---------------- */
  useEffect(() => {
    fetchConfirmationLetters();
  }, []);

  /* ---------------- ON LETTER CHANGE ---------------- */
  useEffect(() => {
    if (!selectedLetters.length) return;

    const mrIds = new Set();
    const receiptIds = new Set();

    selectedLetters.forEach((l) => {
      (l.raw.receipts || []).forEach((r) => {
        (r.mrIds || []).forEach((id) => mrIds.add(id));
        if (r.receiptId) receiptIds.add(r.receiptId);
      });
    });

    fetchMRsByIds([...mrIds]);
    fetchReceiptsByIds([...receiptIds]);
  }, [selectedLetters]);

  /* ---------------- BUILD GROUPED DATA ---------------- */
  const groupedData = useMemo(() => {
    if (!selectedLetters.length) return [];

    const itemsMap = {};

    selectedLetters.forEach((letter) => {
      (letter.raw.receipts || []).forEach((confRec) => {
        const receipt = receiptMap[confRec.receiptId];


        (confRec.items || []).forEach((item) => {
          const itemKey = item.itemId;

         const receiptItem =
  (receipt?.items || []).find(
    (ri) => ri.id == item.receiptVoucherItemId
  ) || {};

          if (!itemsMap[itemKey]) {
            itemsMap[itemKey] = {
              itemName: item.itemName,
              mrs: {},
            };
          }

          (confRec.mrIds || []).forEach((mrId) => {
            
            const mr = mrMap[mrId];

            if (!mr) return;

            const mrItem =
              (mr.items || []).find(
                (i) => i.itemId == item.itemId
              ) || {};


            if (!itemsMap[itemKey].mrs[mrId]) {
              itemsMap[itemKey].mrs[mrId] = {
                mrId: mr.id,
                mrItemId: mrItem.id,
                mrNo: mr.mrNo,
                mrQty: mrItem.qty || 0,
                mrUom: mrItem.uom || item.primaryUom,
                receipts: [],
              };
            }
            let existingAllocatedQty = null;

              const allocation =receiptItem.mrAllocation // {206: 15} 'allocation' {204: 15} 'allocation'
                 
              
              // 🔑 IMPORTANT: key is MR ITEM ID
              existingAllocatedQty =allocation?.[String(mrItem.id)] ?? null;

            itemsMap[itemKey].mrs[mrId].receipts.push({
              
              key: `${itemKey}_${mrId}_${confRec.receiptId}_${item.receiptVoucherItemId}`,
              receiptId: confRec.receiptId,
              receiptItemId: receiptItem?.id,
              receiptNo: receipt?.rvNo || "-",
              documentNo: receipt?.documentNo,
              documentDate: receipt?.documentDate,
              ledgerName: receipt?.ledgerName || "-",
              receiptQty: Number(item.primaryQty),
              receiptUom: item.primaryUom,
              departmentName: receiptItem.departmentName || receiptItem.department || "-",
              existingAllocatedQty,
            });
          });
        });
      });
    });

    return Object.values(itemsMap);
  }, [selectedLetters, mrMap, receiptMap]);

  // useEffect(() => {
  //   setAllocationMap((prev) => {
  //     const updated = {};
  
  //     groupedData.forEach((item) => {
  //       Object.values(item.mrs).forEach((mr) => {
  //         mr.receipts.forEach((r) => {
  //           // 1️⃣ If user already typed, keep it
  //           if (prev[r.key] !== undefined) {
  //             updated[r.key] = prev[r.key];
  //           }
  //           // 2️⃣ Else prefill from DB
  //           else if (
  //             r.existingAllocatedQty !== null &&
  //             r.existingAllocatedQty !== undefined
  //           ) {
  //             updated[r.key] = r.existingAllocatedQty;
  //           }
  //         });
  //       });
  //     });
  
  //     return updated;
  //   });
  // }, [groupedData]);

  // useEffect(() => {
  //   setAllocationMap({});
  //   setEditableKeys({});
  // }, [selectedLetters]);
  
  // /* ---------------- HANDLE ALLOCATION ---------------- */
  // const handleAllocationChange = (key, value, mr) => {
  //   let qty = Number(value) || 0;
  //   if (qty < 0) qty = 0;

  //   const totalAllocated = mr.receipts.reduce((sum, r) => {
  //     if (r.key === key) return sum + qty;
  //     return sum + (Number(allocationMap[r.key]) || 0);
  //   }, 0);

  //   if (totalAllocated > mr.mrQty) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: `Total allocated quantity exceeds MR Qty (${mr.mrQty})`,
  //       toast: true,
  //       position: "top-end",
  //       timer: 1500,
  //       showConfirmButton: false,
  //     });
  //     return;
  //   }

  //   setAllocationMap((prev) => ({ ...prev, [key]: qty }));
  // };
  
  
  useEffect(() => {
    setAllocationMap((prev) => {
      const updated = { ...prev };
  
      groupedData.forEach((item) => {
        Object.values(item.mrs).forEach((mr) => {
          mr.receipts.forEach((r) => {
            // ✅ If user already typed something, keep it
            if (updated[r.key] !== undefined) return;
  
            // ✅ If DB allocation exists, use it
            if (r.existingAllocatedQty !== null && r.existingAllocatedQty !== undefined) {
              updated[r.key] = Number(r.existingAllocatedQty);
            }
            // ✅ Else auto-fill with receiptQty
            else {
              updated[r.key] = Number(r.receiptQty) || 0;
            }
          });
        });
      });
  
      return updated;
    });
  }, [groupedData]);
  
  const handleAllocationChange = (key, value, mr) => {
    let qty = Number(value) || 0;
    if (qty < 0) qty = 0;
  
    // 🔹 find current receipt row
    const currentReceipt = mr.receipts.find(r => r.key === key);
    const receiptQty = Number(currentReceipt?.receiptQty) || 0;
  
    // 🔴 VALIDATION 1: receipt-level cap
    if (qty > receiptQty) {
      Swal.fire({
        icon: "warning",
        title: `Allocation cannot exceed Receipt Qty (${receiptQty})`,
        toast: true,
        position: "top-end",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }
  
    // 🔹 calculate MR total allocation
    const totalAllocated = mr.receipts.reduce((sum, r) => {
      if (r.key === key) return sum + qty;
      return sum + (Number(allocationMap[r.key]) || 0);
    }, 0);
  
    // 🔴 VALIDATION 2: MR-level cap
    if (totalAllocated > mr.mrQty) {
      Swal.fire({
        icon: "warning",
        title: `Total allocated quantity exceeds MR Qty (${mr.mrQty})`,
        toast: true,
        position: "top-end",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }
  
    setAllocationMap((prev) => ({ ...prev, [key]: qty }));
  };
  

  /* ---------------- SAVE ---------------- */
  const buildSavePayload = () => {
    const allocations = [];

    groupedData.forEach((item) => {
      Object.values(item.mrs).forEach((mr) => {
        mr.receipts.forEach((r) => {
          const qty = allocationMap[r.key] ?? null;

          allocations.push({
            receiptVoucherId: r.receiptId,
            receiptVoucherItemId: r.receiptItemId,
            mrId: mr.mrId,
            mrItemId: mr.mrItemId,
            allocatedQty: qty > 0 ? qty : null,
          });
        });
      });
    });

    return allocations;
  };

  // const handleSaveAllocation = async () => {
  //   const allocations = buildSavePayload();

  //   if (!allocations.length) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "No allocation to save",
  //       toast: true,
  //       position: "top-end",
  //       timer: 1500,
  //       showConfirmButton: false,
  //     });
  //     return;
  //   }

  //   await apiClient.post(
  //     `${SERVER_BASE}/saveReceiptMrAllocation`,
  //     { allocations },
  //     { headers: { Authorization: `Bearer ${token}` } }
  //   );

  //   Swal.fire({
  //     icon: "success",
  //     title: "Allocation saved successfully",
  //     toast: true,
  //     position: "top-end",
  //     timer: 1500,
  //     showConfirmButton: false,
  //   });
  // };


  const handleSaveAllocation = async () => {
    // ✅ 1) Row-level validation (Allocated <= Receipt Qty)
    for (const item of groupedData) {
      for (const mr of Object.values(item.mrs)) {
        for (const r of mr.receipts) {
          const qty = Number(allocationMap[r.key]) || 0;
          const receiptQty = Number(r.receiptQty) || 0;
  
          if (qty > receiptQty) {
            Swal.fire({
              icon: "error",
              title: "Invalid Allocation",
              html: `
                <b>Row Error:</b> Allocation cannot exceed Receipt Qty <br/>
                <hr/>
                <b>Item:</b> ${item.itemName}<br/>
                <b>MR No:</b> ${mr.mrNo}<br/>
                <b>Receipt No:</b> ${r.receiptNo}<br/>
                <b>Ledger:</b> ${r.ledgerName}<br/>
                <b>Receipt Qty:</b> ${receiptQty}<br/>
                <b>Entered Allocation:</b> ${qty}
              `,
            });
  
            // ✅ highlight row
            setActiveRowKey(r.key);
            return;
          }
        }
      }
    }
  
    // ✅ 2) MR-level validation (Total allocation <= MR Qty)
    for (const item of groupedData) {
      for (const mr of Object.values(item.mrs)) {
        const totalAllocated = mr.receipts.reduce((sum, r) => {
          return sum + (Number(allocationMap[r.key]) || 0);
        }, 0);
  
        if (totalAllocated > Number(mr.mrQty || 0)) {
          // find the row which caused overflow (last non-zero entered row)
          const lastRow = [...mr.receipts]
            .reverse()
            .find((r) => (Number(allocationMap[r.key]) || 0) > 0);
  
          Swal.fire({
            icon: "error",
            title: "MR Allocation Exceeded",
            html: `
              <b>Total allocated qty cannot exceed MR Qty</b>
              <hr/>
              <b>Item:</b> ${item.itemName}<br/>
              <b>MR No:</b> ${mr.mrNo}<br/>
              <b>MR Qty:</b> ${mr.mrQty}<br/>
              <b>Total Allocated:</b> ${totalAllocated}<br/>
              ${
                lastRow
                  ? `
                  <hr/>
                  <b>Error Row:</b><br/>
                  <b>Receipt No:</b> ${lastRow.receiptNo}<br/>
                  <b>Ledger:</b> ${lastRow.ledgerName}<br/>
                  <b>Entered Allocation:</b> ${Number(allocationMap[lastRow.key]) || 0}
                `
                  : ""
              }
            `,
          });
  
          // ✅ highlight row
          if (lastRow) setActiveRowKey(lastRow.key);
          return;
        }
      }
    }
  
    // ✅ Proceed saving if validations passed
    const allocations = buildSavePayload();
  
    if (!allocations.length) {
      Swal.fire({
        icon: "error",
        title: "No allocation to save",
        toast: true,
        position: "top-end",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }
  
    await apiClient.post(
      `${SERVER_BASE}/saveReceiptMrAllocation`,
      { allocations },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  
    Swal.fire({
      icon: "success",
      title: "Allocation saved successfully",
      toast: true,
      position: "top-end",
      timer: 1500,
      showConfirmButton: false,
    });
  };
  
  const enableEdit = (key) => {
    setEditableKeys((prev) => ({ ...prev, [key]: true }));
  };

  /* ---------------- UI ---------------- */
  return (
    <div className="formcontainer mt-5">
      <h4 className="mb-4">Receipt Allocation</h4>

      <div className="row mb-4">
        <div className="col-md-6">
          <label className="form-label fw-bold">
            Select Confirmation Letter(s)
          </label>
          <Select
            options={letterOptions}
            isMulti
            value={selectedLetters}
            onChange={(val) => setSelectedLetters(val || [])}
          />
        </div>
      </div>

      {groupedData.length > 0 && (
        <>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th style={{ width: 60 }}>S. No</th>
                  <th>Item Name</th>
                  <th>MR No</th>
                  <th>Ledger</th>
                  <th>MR Qty</th>
                  <th>Receipt Qty</th>
                  <th>Allocate Qty</th>
                  <th>Unallocated</th>
                </tr>
              </thead>
              <tbody>
                {groupedData.map((item, itemIndex) => {
                  const mrList = Object.values(item.mrs);
                  const itemRowSpan = mrList.reduce(
                    (sum, mr) => sum + mr.receipts.length,
                    0
                  );

                  let itemRendered = false;
                  

                  return mrList.map((mr) => {
                    let mrRendered = false;

                    const allocatedSum = mr.receipts.reduce(
                      (sum, r) =>
                        sum + (Number(allocationMap[r.key]) || 0),
                      0
                    );

                    
                    
                    const unallocatedQty = mr.mrQty - allocatedSum;
                  
                    return mr.receipts.map((r, idx) => {
                      const isFirstReceiptRow =
                        idx === 0 ||
                        mr.receipts[idx - 1].receiptId !== r.receiptId;
                    
                      const receiptRowSpan = mr.receipts.filter(
                        x => x.receiptId === r.receiptId
                      ).length;
                    
                      return (
                      
                      <tr
                        key={r.key}
                        className={
                          activeRowKey == r.key ? "table-warning" : ""
                        }
                      >
                        
                        {!itemRendered && (
                          <td rowSpan={itemRowSpan} className="text-center fw-semibold">
                            {itemIndex + 1}
                          </td>
                        )}
                        {!itemRendered && (
                          <td rowSpan={itemRowSpan} className="fw-semibold">
                            {item.itemName}
                          </td>
                        )}

                        {!mrRendered && (
                          <td rowSpan={mr.receipts.length}>
                            <Link
                              to={`/MRPreview?voucherId=${mr.mrId}&type=external`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#0d6efd", textDecoration: "none" }}
                            >
                              {mr.mrNo}
                            </Link>
                          </td>
                        )}

{isFirstReceiptRow && (
  <td rowSpan={receiptRowSpan}>
    <div>
      <span>{r.ledgerName}</span>
      <br />
      <span className="text-muted">
        {r.documentNo
          ? `[ ${r.documentNo} - ${moment(r.documentDate).format("DD MMM YY")} ]`
          : ""}
        {" "}
        {r.receiptNo && (
          <Link
            to={`/PreviewExternalReceiptVoucher?voucherId=${r.receiptId}&type=external`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0d6efd", textDecoration: "none" }}
          >
            [ {r.receiptNo} ]
          </Link>
        )}
      </span>
    </div>
  </td>
)}



                        {!mrRendered && (
                          <td rowSpan={mr.receipts.length}>
                            {mr.mrQty}{" "}
                            <span className="text-muted">{mr.mrUom}</span>
                          </td>
                        )}

<td>
  <div>
    <strong>
      {r.receiptQty}{" "}
      <span className="text-muted">{r.receiptUom}</span>
    </strong>
  </div>

  <div style={{ fontSize: "12px", color: "#666" }}>
    ({r.departmentName})
  </div>
</td>


                        <td>
  <div className="d-flex align-items-center gap-1">
    <input
      type="number"
      className="form-control form-control-sm text-end"
      value={allocationMap[r.key] || ""}
      // value={allocationMap[r.key] ?? ""}

      disabled={
        r.existingAllocatedQty !== null &&
        r.existingAllocatedQty !== undefined &&
        !editableKeys[r.key]
      }
      onFocus={() => setActiveRowKey(r.key)}
      onBlur={() => setActiveRowKey(null)}
      onChange={(e) =>
        handleAllocationChange(
          r.key,
          e.target.value,
          mr
        )
      }
    />

    {r.existingAllocatedQty !== null &&
      r.existingAllocatedQty !== undefined &&
      !editableKeys[r.key] && (
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          title="Edit allocation"
          onClick={() =>
            setEditableKeys((prev) => ({
              ...prev,
              [r.key]: true,
            }))
          }
        >
          <FontAwesomeIcon icon={faPen}/>
        </button>
      )}
  </div>
</td>

                        {!mrRendered && (
                          <td rowSpan={mr.receipts.length} className="fw-semibold">
                            {unallocatedQty >= 0 ? unallocatedQty : 0}{" "}
                            <span className="text-muted">{mr.mrUom}</span>
                          </td>
                        )}

                        {(itemRendered = true)}
                        {(mrRendered = true)}
                      </tr>
                    )});
                  });
                })}
              </tbody>
            </table>
          </div>

          <div className="text-end">
            <button
              className="btn btn-success mt-4"
              onClick={handleSaveAllocation}
            >
              Allocate Qty
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ReceiptAllocation;
